import { RenameDocumentDialogContainer } from '@/features/docs/RenameDocumentDialog/RenameDocumentDialogContainer'
import { useFeatures } from '@/contexts/root-store-context'
import { observer } from 'mobx-react-lite'
import { DeleteDocumentDialogContainer } from '@/features/docs/DeleteDocumentDialog/DeleteDocumentDialogContainer'
import { AssignFileTypeDialogContainer } from '@/features/docs/components/AssignFileTypeDialog/AssignFileTypeDialogContainer'
import { UnlinkDocumentDialogContainer } from '@/features/docs/components/UnlinkDocumentDialog/UnlinkDocumentDialogContainer'

/**
 * Inner component which requests the actual loading of the module.
 */
export default observer(function Inner() {
  const { internal } = useFeatures(({ docs }) => ({
    internal: docs.internal(),
  }))

  return (
    <>
      <RenameDocumentDialogContainer
        vm={internal.renameDocumentDialogViewModel}
      />
      <DeleteDocumentDialogContainer
        vm={internal.deleteDocumentDialogViewModel}
      />
      <AssignFileTypeDialogContainer vm={internal.assignFileTypeDialogVm} />
      <UnlinkDocumentDialogContainer
        vm={internal.unlinkDocumentDialogViewModel}
      />
    </>
  )
})
